import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastContainer, ToastOptions } from '@britishcouncil/react-admin';
import 'regenerator-runtime/runtime'; //needed for React Table

import 'react-day-picker/lib/style.css';
import '@britishcouncil/semantic-ui-admin/dist/semantic.min.css';
import './index.css';
import 'react-datepicker/dist/react-datepicker.css';

import { Providers } from './Providers';

const defaultToastOptions: ToastOptions = {
  icon: true,
  position: 'top right',
  displayTime: 5000,
  closeIcon: true,
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
    <ToastContainer defaultOptions={defaultToastOptions} />
  </React.StrictMode>
);
